import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  events: localStorage.getItem('events') && JSON.parse(localStorage.getItem('events'))  || [],
  demoEvent: null,
  emailTemplate: null
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/events/index.js